export function iterateQuerySelectorAll(root, selector, cb)
{
    [].forEach.call(root.querySelectorAll(selector), cb);
}

export function getMatched(element: HTMLElement, selector: string): HTMLElement|null
{
    if(element.matches(selector)) {
        return element;
    }

    let parent = element.parentElement;

    while(parent !== null && parent.matches(selector) === false) {
        parent = parent.parentElement;
    }

    return parent;
}

export function addClass(el, cls)
{
    if(el.classList.contains(cls) === false) {
        el.classList.add(cls);
    }
}

export function removeClass(el, cls)
{
    el.classList.remove(cls);
}

export function findParentBySelector(element, selector)
{
    let current = element.parentNode;

    while(current && ! current.matches(selector)) {
        current = current.parentNode;
    }

    return current;
}
